import React from "react";
import { motion } from "framer-motion";
import content from "../content/content.json";

const columnVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

const Capabilities = () => {
  const { capabilitiesMenu } = content;

  return (
    <motion.div
      className="absolute top-full h-screen left-0 w-full bg-white shadow-lg z-50 py-12"
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      <div className="grid md:grid-cols-3 h-full">
        <motion.div className="bg-gray-300 p-8 h-full flex flex-col" custom={0} variants={columnVariants}>
          <h3 className="font-semibold text-3xl mb-3 text-[#1C1F2B]">{capabilitiesMenu.title}</h3>
          <p className="text-sm md:text-sm text-[#1C1F2B] leading-loose">{capabilitiesMenu.description}</p>
        </motion.div>

        <motion.div className="bg-gray-100 p-8 h-full" custom={1} variants={columnVariants}>
          <h3 className="text-sm font-bold text-[#1C1F2B] mb-6">{capabilitiesMenu.riskCapitalHeading}</h3>
          <ul className="space-y-3 text-lg text-gray-700">
            {capabilitiesMenu.riskCapitalLinks.map((link) => (
              <li key={link} className="hover:text-[#D00] cursor-pointer">
                {link}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div className="bg-gray-50 p-8 h-full" custom={2} variants={columnVariants}>
          <h3 className="text-sm font-bold text-[#1C1F2B] mb-6">{capabilitiesMenu.humanCapitalHeading}</h3>
          <ul className="space-y-3 text-lg text-gray-700">
            {capabilitiesMenu.humanCapitalLinks.map((link) => (
              <li key={link} className="hover:text-[#D00] cursor-pointer">
                {link}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Capabilities;

